import { useState } from "react";
import { Link } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Shell hideNav>
      <div className="fade-up">
        <p className="eyebrow">Account recovery</p>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight">Forgot your password?</h1>
        {sent ? (
          <div className="panel mt-8 p-5" data-testid="forgot-sent">
            <p className="text-sm text-slate-200">If an account exists for <span className="font-semibold text-white">{email}</span>, we've sent a reset link. It works for 60 minutes.</p>
            <p className="mt-2 text-xs text-slate-500">Didn't get it? Check spam, or try again in a couple of minutes.</p>
            <Link to="/login" className="btn-secondary mt-5 w-full" data-testid="forgot-back-to-login">Back to log in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
            <p className="text-sm text-slate-400">Enter the email you registered with and we'll send you a link to set a new password.</p>
            <label className="block">
              <span className="eyebrow mb-2 block">Email</span>
              <input className="field" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required autoComplete="email" data-testid="forgot-email-input" />
            </label>
            {error && <p className="rounded-xl border border-rose-500/40 bg-rose-500/10 px-4 py-3 text-sm text-rose-300" data-testid="forgot-error">{error}</p>}
            <button className="btn-primary w-full" disabled={busy} data-testid="forgot-submit-button">{busy ? "Sending…" : "Send reset link"}</button>
            <p className="text-center text-sm text-slate-400"><Link to="/login" className="font-semibold text-white underline-offset-4 hover:underline" data-testid="forgot-login-link">Back to log in</Link></p>
          </form>
        )}
      </div>
    </Shell>
  );
}
